var React = require('react');

function PlayRound (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.14209 12.9712C5.41504 12.9712 5.64355 12.876 5.93555 12.7109L13.4131 8.37549C13.9653 8.05811 14.1812 7.81689 14.1812 7.42334C14.1812 7.02979 13.9653 6.78857 13.4131 6.47119L5.93555 2.14209C5.64355 1.9707 5.41504 1.87549 5.14209 1.87549C4.62793 1.87549 4.26611 2.26904 4.26611 2.89746V11.9492C4.26611 12.5776 4.62793 12.9712 5.14209 12.9712Z","fill":"white"}));
}

PlayRound.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = PlayRound;

PlayRound.default = PlayRound;
